module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('span', [_vm._v("To my artist friends,"), _c('br'), _vm._v("without whom life would be such a bore.")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_vm._v("The past, though broken, is mirrored in the present, and when turned, the fragments are either flung apart to make their patterns or tumble into place as time collapses.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a64f899","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Dedication.vue
// module id = 72
// module chunks = 0